import classNames from "classnames";
import PropTypes from "prop-types";

export const List = ({ className, size = 16, fill = "currentColor", ...props }) => {
	const listClassName = classNames("list-icon", {
		[className]: className?.length > 0,
	});

	return (
		<svg
			className={listClassName}
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			aria-hidden="true"
			{...props}
		>
			<path
				d="M1.50049 3.16667C1.50049 2.52233 2.02282 2 2.66716 2H13.3338C13.9782 2 14.5005 2.52233 14.5005 3.16667V3.83333C14.5005 4.47767 13.9782 5 13.3338 5H2.66716C2.02282 5 1.50049 4.47767 1.50049 3.83333V3.16667Z"
				fill={fill}
			/>
			<path
				d="M1.50049 7.49998C1.50049 6.85565 2.02282 6.33331 2.66716 6.33331H13.3338C13.9782 6.33331 14.5005 6.85565 14.5005 7.49998V8.16665C14.5005 8.81098 13.9782 9.33331 13.3338 9.33331H2.66716C2.02282 9.33331 1.50049 8.81098 1.50049 8.16665V7.49998Z"
				fill={fill}
			/>
			<path
				d="M1.50049 11.8334C1.50049 11.189 2.02282 10.6667 2.66716 10.6667H13.3338C13.9782 10.6667 14.5005 11.189 14.5005 11.8334V12.5C14.5005 13.1444 13.9782 13.6667 13.3338 13.6667H2.66716C2.02282 13.6667 1.50049 13.1444 1.50049 12.5V11.8334Z"
				fill={fill}
			/>
		</svg>
	);
};

List.propTypes = {
	size: PropTypes.number,
	fill: PropTypes.string,
};
